import { useFormik } from 'formik'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import * as Yup from 'yup'

import ButtonCinestar from '../../Buttons/ButtonCinestar/ButtonCinestar'
import Checkbox from '../../Inputs/Checkbox/Checkbox'
import Typography from '../../Typography/Typography'
import FormLayout from '../FormLayout/FormLayout'
import hocFormLostCard from './hocFormLostCard'

import './FormLostCard.scss'

const FormLostCard = ({ lostCard, loading, sectionRef }) => {
    const intl = useIntl()

    const formik = useFormik({
        initialValues: {
            checkBox: false,
        },
        validationSchema: Yup.object({
            checkBox: Yup.boolean().oneOf([true], intl.formatMessage({ id: 'forms.lostCard.checkBoxNotChecked' })),
        }),
        onSubmit: (values) => lostCard(values),
    })

    return (
        <Container fluid className="lost-card d-flex flex-column" ref={sectionRef}>
            <Typography variant={'h2'}>{intl.formatMessage({ id: 'forms.lostCard.title' })}</Typography>
            <FormLayout
                size={'lg'}
                color={'purple'}
                onSubmit={formik.handleSubmit}
                className={`lost-card--form d-flex flex-column`}
            >
                <Typography variant={'h3'}>{intl.formatMessage({ id: 'forms.lostCard.description' })}</Typography>
                <Checkbox
                    name={'checkBox'}
                    id={'checkBox'}
                    color={'purple'}
                    error={formik?.errors?.checkBox}
                    touched={formik?.touched?.checkBox}
                    {...formik.getFieldProps('checkBox')}
                    label={intl.formatMessage({ id: 'forms.lostCard.label' })}
                    onBlur={formik?.handleBlur}
                />
                <Container fluid>
                    <ButtonCinestar variant={'primary-v1'} type={'submit'} disabled={loading}>
                        {intl.formatMessage({
                            id: 'buttons.buttonSave',
                        })}
                    </ButtonCinestar>
                </Container>
            </FormLayout>
        </Container>
    )
}

export default hocFormLostCard(FormLostCard)
